import { IPartnerShopInformation } from '../../common/interfaces/partnershop.interface';
import { EPhoneType } from '../../common/enums/customers.enum';

export default class PartnerShopHelper {
  private static initialPartnerShopData: IPartnerShopInformation = {
    address: {
      city: ``,
      country: ``,
      latitude: 0,
      longitude: 0,
      postalCode: ``,
      street: ``,
      streetNumber: ``,
    },
    company: ``,
    email: ``,
    firstname: ``,
    image: ``,
    lastname: ``,
    longDescription: ``,
    phone: {
      mobile: {
        code: ``,
        country: ``,
        number: ``,
        type: EPhoneType.LANDLINE,
      },
      telephone: {
        code: ``,
        country: ``,
        number: ``,
        type: EPhoneType.MOBILE,
      },
    },
    shortDescription: ``,
  };

  public static getInitialPartnerShopData(): IPartnerShopInformation {
    return JSON.parse(JSON.stringify(this.initialPartnerShopData));
  }

  public static isPageInPartnerShop(): boolean {
    const hostname = window.location.hostname.split(`.`)[0];
    return hostname !== `localhost`
           && hostname !== `ringana`
           && hostname !== `www`
           && hostname !== `ringana-local`;
  }
}
